import { Item } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Products/components/item";
import { Items } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Products/components/items";
import { ShowAllButton } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Products/components/showAllButton";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/Products/products.base";

export const Products = Object.assign(Base, {
    Items: Items,
    Item: Item,
    ShowAllButton: ShowAllButton
});
